var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavyRain01 = function SvgHeavyRain01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.43,
    y1: 179.15,
    x2: 183.34,
    y2: 38.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.28,
    y1: 202.92,
    x2: 203.18,
    y2: 62.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 55.12,
    y1: 226.68,
    x2: 223.03,
    y2: 86.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 43.56,
    y1: 212.83,
    x2: 211.46,
    y2: 72.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 63.4,
    y1: 236.59,
    x2: 231.31,
    y2: 96.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.08,
    y1: 160.78,
    x2: 167.99,
    y2: 20.54,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.6,163c-7.96,0-14.44-6.48-14.44-14.44,0-9,10.77-20.79,12-22.11l2.44-2.61,2.44,2.61c1.23,1.31,12,13.1,12,22.11,0,7.96-6.48,14.44-14.44,14.44ZM55.6,133.83c-3.66,4.51-7.76,10.83-7.76,14.73,0,4.28,3.48,7.76,7.76,7.76s7.76-3.48,7.76-7.76c0-3.9-4.11-10.22-7.76-14.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.9,163c-7.96,0-14.44-6.48-14.44-14.44,0-9,10.77-20.79,12-22.11l2.44-2.61,2.44,2.61c1.23,1.31,12,13.1,12,22.11,0,7.96-6.48,14.44-14.44,14.44ZM103.9,133.83c-3.66,4.51-7.76,10.83-7.76,14.73,0,4.28,3.48,7.76,7.76,7.76s7.76-3.48,7.76-7.76c0-3.9-4.11-10.22-7.76-14.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.19,163c-7.96,0-14.44-6.48-14.44-14.44,0-9,10.77-20.79,12-22.11l2.44-2.61,2.44,2.61c1.23,1.31,12,13.1,12,22.11,0,7.96-6.48,14.44-14.44,14.44ZM152.19,133.83c-3.66,4.51-7.76,10.83-7.76,14.73,0,4.28,3.48,7.76,7.76,7.76s7.76-3.48,7.76-7.76c0-3.9-4.11-10.22-7.76-14.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.75,200c-7.96,0-14.44-6.48-14.44-14.44,0-9.01,10.77-20.79,12-22.11l2.44-2.61,2.44,2.61c1.23,1.31,12,13.1,12,22.11,0,7.96-6.48,14.44-14.44,14.44ZM79.75,170.83c-3.66,4.51-7.76,10.83-7.76,14.73,0,4.28,3.48,7.76,7.76,7.76s7.76-3.48,7.76-7.76c0-3.91-4.1-10.23-7.76-14.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.04,200c-7.96,0-14.44-6.48-14.44-14.44,0-9.01,10.77-20.79,12-22.11l2.44-2.61,2.44,2.61c1.23,1.31,12,13.1,12,22.11,0,7.96-6.48,14.44-14.44,14.44ZM128.05,170.83c-3.66,4.51-7.76,10.83-7.76,14.73,0,4.28,3.48,7.76,7.76,7.76s7.76-3.48,7.76-7.76c0-3.91-4.1-10.23-7.76-14.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M153.29,29.43c-3.27,0-6.62.44-10.15,1.35C134.5,11.97,116.05,0,95.21,0c-23.08,0-43.31,14.77-50.34,36.75-.64,1.99.46,4.12,2.45,4.75,2,.64,4.11-.46,4.75-2.45,6.03-18.84,23.37-31.49,43.15-31.49,17.58,0,33.17,9.96,40.71,25.66-5.19,2.37-8.78,5.87-10.98,8.67-1.29,1.64-1.01,4.01.63,5.31.69.55,1.52.81,2.34.81,1.12,0,2.22-.49,2.97-1.44,2.04-2.59,5.64-6.02,11.12-7.59.02,0,.1-.03.13-.04,4.03-1.31,7.68-1.95,11.16-1.95,19.96,0,36.21,16.24,36.21,36.21s-16.25,36.21-36.21,36.21H37.78c-15.04,0-27.28-12.23-27.28-27.27s12.24-27.28,27.28-27.28c2.22,0,4.54.36,7.3,1.14,3.62,1.09,6.97,3.05,9.45,5.51.74.73,1.7,1.1,2.66,1.1s1.94-.37,2.68-1.11c1.47-1.48,1.46-3.87-.02-5.34-3.35-3.34-7.84-5.96-12.63-7.41-.01,0-.02,0-.04,0-.01,0-.02-.01-.03-.02-3.46-.97-6.44-1.42-9.38-1.42-19.21,0-34.83,15.63-34.83,34.83s15.63,34.83,34.83,34.83h115.51c24.14,0,43.77-19.63,43.77-43.77,0-24.14-19.63-43.77-43.77-43.77"
  })));
};
export default SvgHeavyRain01;